<div class="blob-stage" aria-hidden="true">
  <div class="blob blob-back"></div>
  <div class="blob blob-front">
    <app-mesh-gradient
      [speed]="1"
      [seed]="42"
      [blurPx]="10"
      [colors]="['#77CEC7', '#77CEC7', '#505ED7', '#77CEC7']"
      [grainOpacityPercent]="0"
      [grainFrequency]="0.3"
      [grainOctaves]="0"
      [bleedPercent]="10"
      [frequency]="1"
    ></app-mesh-gradient>
  </div>
</div>
